<template>
  <div>
    <div class="login-container">
      <img class="logo mb-4" src="/logo.png" />
      <div class="box text-center">
        <h3 class="mx-auto mt-4 mb-5" style="font-weight: 400">
          ایجاد حساب کاربری
        </h3>
        <v-text-field
          outlined
          dense
          hide-details
          class="mb-6"
          placeholder="* نام و نام خانوادگی"
          v-model="newAccount.name"
          color="#444"
        ></v-text-field>
        <v-text-field
          outlined
          dense
          hide-details
          class="mb-6"
          placeholder="* شماره همراه"
          v-model="newAccount.mobile"
          color="#444"
          type="number"
        ></v-text-field>

        <v-text-field
          outlined
          dense
          hide-details
          class="mb-6"
          placeholder="* رمز عبور"
          type="password"
          v-model="newAccount.password"
          color="#444"
        ></v-text-field>
        <v-text-field
          outlined
          dense
          hide-details
          class="mb-6"
          type="password"
          placeholder="* تکرار رمز عبور"
          v-model="newAccount.retypedPass"
          color="#444"
        ></v-text-field>

        <v-text-field
          outlined
          dense
          hide-details
          class="mb-6"
          placeholder="شهر (اختیاری)"
          v-model="newAccount.city"
          color="#444"
        ></v-text-field>
        <v-text-field
          outlined
          dense
          hide-details
          class="mb-6"
          placeholder="ایمیل (اختیاری)"
          type="email"
          v-model="newAccount.email"
          color="#444"
        ></v-text-field>
        <!-- <div class="fs-xsmall text-right">
            زدن دکمه "ایجاد حساب" به منزله موافقت شما با <span class="link">شرایط استفاده از خدمات</span> و <span class="link">سیاست حفظ حریم خصوصی</span> می‌باشد.
        </div> -->
        <div class="my-4">
          <v-btn
            class="primary"
            height="44"
            style="width: 100%"
            :loading="busy"
            @click="submit"
            :disabled="!checkFields"
            >ایجاد حساب</v-btn
          >
        </div>
      </div>
      <div class="pt-2 pb-12 fs-small">
        پیش از این ثبت نام کرده‌اید؟
        <span class="link" @click="$router.push('/login')"
          >ورود به حساب کاربری</span
        >
      </div>
    </div>
    <br />
    <br />
  </div>
</template>

<script>
import md5 from "js-md5";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      newAccount: {
        name: "",
        email: "",
        password: "",
        retypedPass: "",
        mobile: "",
        country: "",
        city: "",
      },
      busy: false,
    };
  },
  methods: {
    ...mapMutations(["setUserName"]),
    submit() {
      this.busy = true;
      this.$http
        .post(this.baseUrl + "/auth/signup", {
          name: this.newAccount.name,
          email: this.newAccount.email ? this.newAccount.email : undefined,
          password: md5(this.newAccount.password),
          repeatPassword: md5(this.newAccount.retypedPass),
          mobile: this.newAccount.mobile,
          city: this.newAccount.city ? this.newAccount.city : undefined,
        })
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            localStorage.clear();
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("name", res.data.name);
            this.setUserName(this.newAccount.name);
            this.$router.push("/dashboard");
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
  },
  computed: {
    checkFields() {
      if (
        !this.newAccount.name ||
        !this.newAccount.password ||
        !this.newAccount.retypedPass ||
        !this.newAccount.mobile
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss"></style>
